import { Col, Row, message } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  ButtonItem,
  Form,
  ModalItem,
  FormItem,
  InputItem,
  ErrorItem,
  TextAreaItem,
} from "../../../../Components/Items";
import axios from "axios";

// Solo edita los campos libres/editables de la unidad — nunca costo, fechas de
// depreciación, snapshot de depreciación ni estado (mismo criterio que el
// backend en editarUnidadActivoFijo / CAMPOS_EDITABLES_UNIDAD).
class EditarUnidadActivoFijo extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible) {
      this.consultarInformacionUnidad();
    }
  }

  consultarInformacionUnidad() {
    this.setState({ loading: true });
    axios
      .post(
        "activosFijos/datosUnidadActivoFijo",
        { entradaSalidaId: this.props.entradaSalidaId, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
          message.error("Error al consultar la información de la unidad");
          this.setState({ loading: false });
        } else {
          this.setState({ loading: false });
          this.formRef.current.setFieldsValue({ ...res.data.unidad });
        }
      });
  }

  cerrarEditarUnidadActivoFijo(codigo) {
    this.props.cerrarEditarUnidadActivoFijo(codigo);
    this.formRef.current.resetFields();
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  onFinish(values) {
    this.setState({ loading: true });
    axios
      .post(
        "activosFijos/editarUnidadActivoFijo",
        { empresaId: this.props.empresaId, entradaSalidaId: this.props.entradaSalidaId, ...values },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se ha editado la unidad");
          this.cerrarEditarUnidadActivoFijo(res.data.codigo);
        } else {
          message.error(res.data.message || "Hubo un error y la unidad no se editó");
        }
      });
  }

  render() {
    return (
      <ModalItem
        title="Editar Unidad de Activo"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarEditarUnidadActivoFijo.bind(this)}
        paddingTop
        width={700}
      >
        <Form
          ref={this.formRef}
          name="editarUnidadActivoFijo"
          layout
          bottom={
            <ButtonItem type="primary" htmlType="submit" style={{ display: "block", margin: "0 0 0 auto" }}>
              Editar
            </ButtonItem>
          }
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
          <Row>
            <Col span={12}>
              <FormItem name="serieActivo" label="Serie" margin pattern tooltip={{ title: "Prefijo de la serie de esta unidad. Editar esto NO recalcula el folio autogenerado, solo cambia el texto guardado." }}>
                <InputItem placeholder="Serie" />
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem name="numero" label="Folio" margin pattern tooltip={{ title: "Consecutivo de folio de esta unidad." }}>
                <InputItem placeholder="Folio" />
              </FormItem>
            </Col>
          </Row>
          <FormItem name="ubicacionFisica" label="Ubicación Física" margin pattern tooltip={{ title: "Dónde está físicamente el activo ahora (ej. si se movió de oficina)." }}>
            <InputItem placeholder="Ej. Oficina Gerencia, Planta 1" />
          </FormItem>
          <FormItem name="fabricante" label="Fabricante" margin pattern tooltip={{ title: "Fabricante del equipo/bien." }}>
            <InputItem placeholder="Fabricante" />
          </FormItem>
          <FormItem name="proveedor" label="Proveedor" margin pattern tooltip={{ title: "Proveedor que vendió esta unidad." }}>
            <InputItem placeholder="Proveedor" />
          </FormItem>
          <FormItem name="ordenDeCompra" label="Orden de Compra" margin pattern tooltip={{ title: "Referencia a la orden de compra/factura relacionada." }}>
            <InputItem placeholder="Referencia de orden de compra" />
          </FormItem>
          <FormItem name="observaciones" label="Observaciones" margin pattern tooltip={{ title: "Notas libres sobre esta unidad." }}>
            <TextAreaItem placeholder="Observaciones" />
          </FormItem>
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(EditarUnidadActivoFijo);
